import * as React from "react";

import AsyncComponent from "components/AsyncComponent";
import { SPPageLoader } from "Apps/ticketing/components/Desktop/Loader/EmptyView";



export const DesktopPage: any = AsyncComponent(callback => {
    require.ensure([], (require) => {
        const DesktopRoute = require("../components/Desktop").PageRoute;
        callback(DesktopRoute)
    }, "desktop");

},()=><SPPageLoader/>);

export const EmbedPage: any  = AsyncComponent(callback => {
    require.ensure([], (require) => {
        const EmbedRoute = require("../components/Desktop").EmbedRoute;
        callback(EmbedRoute)
    }, "desktop");
});


// WEBPACK FOOTER //
// ./src/Apps/ticketing/routes/desktop.tsx